import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, FormSection, change } from 'redux-form';
import Geosuggest from 'react-geosuggest';
import { RenderField, RenderTextareaField, RenderSubmitButton, RenderCheckboxRadioField } from '../../../common/form';
import AddressFields from '../../../common/form/AddressFields';
import * as Validations from '../../../common/form/commonValidations';
import { updatePoi, addPoi } from '../../../../actions/website/entities/PoiActions';
import { hideModal } from '../../../../actions/ModalActions';
import { getPlaceDetails } from '../../../../actions/website/PlacesActions';
import FileInput from '../../../common/form/FileInput';
import { tempUpload, saveCrop } from '../../../../actions/website/FileUploadActions';
import CropModal from './CropModal';

class PoiForm extends Component {
  constructor(props) {
    super(props);
    this.toggleAddress = this.toggleAddress.bind(this);
    this.toggleActiveClass = this.toggleActiveClass.bind(this);
    this.state = {
      autoAddress: !this.props.initialValues.id,
      showCrop: false,
      activeIdx: undefined
    };
  }
  componentWillReceiveProps(nextProps) {
    const { onPhotoSelected, address, handleAddress } = this.props;
    if (nextProps.uploadedPhoto.s3_key && (this.props.uploadedPhoto.s3_key !== nextProps.uploadedPhoto.s3_key)) {
      this.setState({ showCrop: true });
    } else if (nextProps.uploadedPhoto.uuid && (this.props.uploadedPhoto.uuid !== nextProps.uploadedPhoto.uuid)) {
      this.setState({ showCrop: false });
      onPhotoSelected(nextProps.uploadedPhoto.uuid);
    }
    if (Object.keys(nextProps.address).length > 0 && nextProps.address !== address && !nextProps.address.busy) {
      handleAddress(nextProps.address);
    }
  }
  toggleAddress() {
    this.setState({ autoAddress: !this.state.autoAddress });
  }

  toggleActiveClass(idx) {
    this.setState({
      activeIdx: idx
    });
  }
  render() {
    const { handleSubmit, submitting, valid, getSuggestion, photos, setGooglePhoto, onPhotoSelect, placePhotoUrl, uploadedPhoto, address, isUpdate, savePhotoCrop } = this.props;
    const { activeIdx } = this.state;
    return (
      <div className="entity-form">
        <div className="modal-header">
          {!this.state.autoAddress && !address.busy &&
          <span className="text-button back-button" onClick={this.toggleAddress}><i className="zolaicon zolaicon-chevron-left" /> Back</span>
          }
          <h3 className="modal-title">{isUpdate ? 'Edit' : 'Add'} Recommendation</h3>
        </div>
        <div className="modal-body clearfix">
          <form onSubmit={handleSubmit} id="poi-form" noValidate>
            {this.state.autoAddress && !address.busy &&
              <div className="col-sm-6 col-sm-offset-3">
                <div className="form-group">
                  <Field
                    name="place"
                    id="poi-place"
                    label="Recommendation Name Or Address"
                    placeholder="Recommend a fun place for your guests to visit"
                    component={Geosuggest}
                    onSuggestSelect={(suggestion) => {
                      getSuggestion(suggestion);
                      this.toggleAddress();
                    }}
                    inputClassName="form-control"
                  />
                  <span className="pull-right text-button" style={{ paddingTop: '5px' }} onClick={this.toggleAddress} role="button">Or Enter Address Manually &rsaquo;</span>
                </div>
              </div>
            }
            {address.busy &&
              <div className="busy-loader center-block" />
            }
            {!this.state.autoAddress && !address.busy &&
              <div>
                <Field
                  component={RenderField}
                  name="title"
                  id="poi-title"
                  label="Recommendation Name"
                  placeholder="Mount Tamalpais Hike"
                  type="text"
                  required
                  maxChars={100}
                  validate={[Validations.REQUIRED, Validations.MAX_LENGTH_100]}
                  disabled={this.state.showCrop}
                />
                {photos && !uploadedPhoto.uuid && <strong className="form-label">Photos <small>(pick one)</small></strong>}
                {(!photos || uploadedPhoto.uuid) && <strong className="form-label">Photo <small>(max file size 5 MB)</small></strong>}
                <div className="place-photos">
                  {!this.state.showCrop && !uploadedPhoto.busy && !uploadedPhoto.uuid && photos && photos.map((photo, idx) => (
                    <Field
                      component={RenderCheckboxRadioField}
                      name="google_place_photo_reference"
                      type="radio"
                      id={`photo-${idx}`}
                      labelElem={
                        <div className={['place-photo', activeIdx === idx ? 'active' : ''].join(' ')} onClick={() => this.toggleActiveClass(idx)}>
                          <img src={`https://maps.googleapis.com/maps/api/place/photo?key=AIzaSyAgV5PcM4xeWCt0L-8ssJe0Qp43jOemz2c&photoreference=${photo.photo_reference}&maxwidth=400`} alt="place" />
                        </div>
                      }
                      key={idx}
                      value={photo.photo_reference}
                      onChange={e => setGooglePhoto(e, photo)}
                    />
                  ))}
                  {!this.state.showCrop && !uploadedPhoto.busy &&
                  <div className="upload">
                    <FileInput className="place-photo" onSelect={file => onPhotoSelect(file, 'poiPhoto')} inputId={'poiPhoto'} filePreview={uploadedPhoto.cloudfront_url ? uploadedPhoto.cloudfront_url : placePhotoUrl} />
                  </div>
                  }
                  {this.state.showCrop && uploadedPhoto.s3_key && !uploadedPhoto.busy &&
                  <CropModal onCropSelect={crop => savePhotoCrop(crop, uploadedPhoto)} aspectRatio={1} imageUrl={uploadedPhoto.url} minimal />
                  }
                  {uploadedPhoto.busy &&
                    <div className="busy-loader margin-top margin-bottom center-block" />
                  }
                </div>
                <FormSection name={''}>
                  <AddressFields selector={'poiForm'} optional disabled={this.state.showCrop} />
                </FormSection>
                <Field
                  component={RenderField}
                  name="url"
                  id="poi-url"
                  label="Recommendation Website Address"
                  type="url"
                  placeholder="http://"
                  disabled={this.state.showCrop}
                />
                <Field
                  component={RenderTextareaField}
                  name="description"
                  id="poi-description"
                  label="Note For Guests"
                  placeholder="We went here on our first date. Needless to say, we had a blast."
                  maxChars={1000}
                  validate={Validations.MAX_LENGTH_1000}
                  disabled={this.state.showCrop}
                />
                <RenderSubmitButton pristine={false} submitting={submitting} valid={valid} disabled={this.state.showCrop || uploadedPhoto.busy} />
              </div>
            }
          </form>
        </div>
      </div>
    );
  }
}

PoiForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({
    id: PropTypes.number
  }),
  getSuggestion: PropTypes.func,
  photos: PropTypes.arrayOf(PropTypes.shape({})),
  setGooglePhoto: PropTypes.func,
  onPhotoSelect: PropTypes.func,
  uploadedPhoto: PropTypes.shape({
    uuid: PropTypes.string,
    cloudfront_url: PropTypes.string,
    s3_key: PropTypes.string
  }),
  onPhotoSelected: PropTypes.func,
  placePhotoUrl: PropTypes.string,
  address: PropTypes.shape({ busy: PropTypes.bool }),
  isUpdate: PropTypes.bool,
  handleAddress: PropTypes.func,
  savePhotoCrop: PropTypes.func,
};

const PoiFormInstance = reduxForm({
  form: 'poiForm',
  enableReinitialize: true
})(PoiForm);

const mapStateToProps = state => ({
  initialValues: state.website.entities.byId[state.website.entities.selectedEntityId] || {},
  photos: state.website.entities.address ? state.website.entities.address.photos : undefined,
  uploadedPhoto: state.website.entities.filePreview.poiPhoto || {},
  placePhotoUrl: state.website.entities.selectedEntityId ? state.website.entities.byId[state.website.entities.selectedEntityId].image_url : undefined,
  address: state.website.entities.address
});

const mapDispatchToProps = dispatch => ({
  onSubmit: (poiFormRequest) => {
    if (poiFormRequest.id) {
      dispatch(updatePoi(poiFormRequest));
    } else {
      dispatch(addPoi(poiFormRequest));
    }
    dispatch(hideModal());
  },
  getSuggestion: (suggestionData) => {
    dispatch(getPlaceDetails(suggestionData.placeId, suggestionData.label, 'title'));
  },
  setGooglePhoto: (e, photo) => {
    if (e.target.checked) {
      dispatch(change('poiForm', 'google_place_photo_html_attribution', photo.html_attribution));
      dispatch(change('poiForm', 'image_id', ''));
    }
  },
  onPhotoSelect: (file) => {
    dispatch(tempUpload(file, 'poiPhoto'));
    dispatch(change('poiForm', 'google_place_photo_html_attribution', ''));
    dispatch(change('poiForm', 'google_place_photo_reference', ''));
  },
  onPhotoSelected: (imageId) => {
    dispatch(change('poiForm', 'image_id', imageId));
  },
  handleAddress: (address) => {
    Object.keys(address).map(key => (
      dispatch(change('poiForm', key, address[key]))
    ));
  },
  savePhotoCrop: (crop, image) => {
    dispatch(saveCrop(image.s3_bucket, image.s3_key, crop, image.content_type, 'poiPhoto'));
  }
});

const PoiFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PoiFormInstance);

export default PoiFormContainer;



/** WEBPACK FOOTER **
 ** ./src/components/manage/website/entities/PoiForm.jsx
 **/